import React from 'react';
import { NativeSelect } from '@material-ui/core';

export default function FeatureOverrideSelect({ label, choice, onInPlan, onChange }) {
  return (
    <NativeSelect value={choice} inputProps={{ 'aria-label': label }} onChange={event => onChange(event.target.value)}>
      <option value="plan">{`Plan default (${onInPlan ? 'On' : 'Off'})`}</option>
      <option value="on">On</option>
      <option value="off">Off</option>
    </NativeSelect>
  );
}
